<div id="subscribedReportsWrapper" [ngClass]="{ 'placeholder-height': !recordsToShow.length }">
	<div class="subscribed-records" [ngClass]="{ 'min-height-500': loaderService.getFlag.on }">
		<div class="no-records" *ngIf="!loaderService.getFlag.on && recordsToShow.length === 0 && !optedOut">
			<div class="no-records-container" *ngIf="!showDefaultMessage" [dcrContent]="{ innerHTML: noRecordMessageKey }"></div>
			<div class="no-records-container" *ngIf="showDefaultMessage" dcrContent [dcrKeys]="[noRecordMessageKey]">
				<p>You’re not currently subscribed.</p>
				<p>
					Visit our <a href="libraryUrl" hrefResolver target="_blank" class="text-16-bold vi-anchor">Literature Library</a> or
					<a href="screenerDefault" hrefResolver target="_blank" class="text-16-bold vi-anchor">Product screener</a> to sign up for timely product materials and more.
				</p>
			</div>
		</div>
		<div class="no-records" *ngIf="!loaderService.getFlag.on && optedOut">
			<div class="no-records-container">
				<div>Our records indicate that you have requested to be opted out of receiving BlackRock subscription emails.</div>
				<div>To subscribe, you must <a href="javascript:void(0)" (click)="optIn()">opt back in.</a></div>
			</div>
		</div>

		<ul class="records-list text-14" *ngIf="recordsToShow.length > 0">
			<li class="record" *ngFor="let record of recordsToShow">
				<div class="left record-name">
					<a [hidden]="record.unSub" class="name text-14-bold" href="literatureUrl" target="_blank" [hrefArgs]="record.documentPath" hrefResolver>
						<icon type="download"></icon> <span class="icon-caption">{{ record.title }}</span>
					</a>
					<span *ngIf="supportSubUnsub" [hidden]="!record.unSub" class="float-left">
						You have unsubscribed from {{ record.title }}
						<strong>
							<a
								[hidden]="!record.documentSearchableOnVenue || record.processing"
								class="text-underline text-14-bold"
								href="javascript:void(0)"
								(click)="manageDocumentSubscription(record, RESUBSCRIBE)"
							>
								Undo Unsubscribe
							</a>
							<icon [hidden]="!record.processing" type="circle-o-notch" class="spinner fa-spin"></icon>
						</strong>
					</span>
				</div>

				<div class="right">
					<span [hidden]="record.unSub" class="icon-caption record-date"> {{ record.publicationDate | date: 'dd MMM yyyy' }} </span>
					<ng-container *ngIf="supportSubUnsub">
						<a [hidden]="record.unSub || record.processing" (click)="manageDocumentSubscription(record, UNSUBSCRIBE)" class="cursor-pointer">
							<icon type="trash-o"></icon>
						</a>
						<icon [hidden]="record.unSub || !record.processing" type="circle-o-notch" class="fa-spin"> </icon>
					</ng-container>
				</div>
			</li>
		</ul>
	</div>

	<!--A view more/less button-->
	<div *ngIf="showViewMore" class="view-more-container" (click)="toggleViewButton($event)">
		<a [hidden]="viewMoreLess" class="view-more-sub">
			<span [dcrContent]="{ innerHTML: 'VIEW_ALL_LABEL ? View All' }" class="icon-caption"></span> <icon type="caret-down"></icon>
		</a>
		<a [hidden]="!viewMoreLess" class="view-more-sub">
			<span [dcrContent]="{ innerHTML: 'VIEW_LESS_LABEL ? View Less' }" class="icon-caption"></span> <icon type="caret-up"></icon>
		</a>
	</div>

	<bfa-modal [isVisible]="isModalVisible" [enableBackdrop]="true" [enableClose]="false">
		<section
			class="message"
			[dcrContent]="{ innerHTML: 'UNSUBSCRIBE_WARNING ? If you unsubscribe from this document, you will not be able to subscribe again or undo this action' }"
		></section>
		<footer class="text-align-center">
			<button dz-button (click)="manageRecord(true, UNSUBSCRIBE)" [dcrContent]="{ innerHTML: 'UNSUBSCRIBE_PROCEED_LABEL ? Proceed' }"></button>
			<button dz-button color="secondary" (click)="isModalVisible = false" [dcrContent]="{ innerHTML: 'UNSUBSCRIBE_DISCARD_LABEL ? Discard' }"></button>
		</footer>
	</bfa-modal>
</div>
